

import { useReducer, useEffect } from 'react';
import formReducer from '../../reducer/formReducer';
import initialState from '../../state/initialState';
import { setFormTemplatesList, isLoading, setAlert, setUserDetails , setAgentDetails, setAllAgentNames} from '../../state/action';
import { getAllForms } from '../../services/firebase/form/formTable';
import { APP_TOKEN } from '../../constants/app-token';
import { decryptData } from '../../utils/utilities';
import useAuth from '../../hooks/useAuth';
import { fetchAllUsers, fetchUserByID } from '../../services/real-star-api/users/user';
import { getAllPDFTemplates } from '../../services/firebase/pdfTemplates/tb_pdfTemlates';
import { ROLE_ID } from '../../constants/roles';

const useApp = () => {
    const [appState, dispatch] = useReducer(formReducer, initialState)
    const { auth, setAuth } = useAuth();
    
    useEffect(() => {
        let isMounted = true;

        const tokenValidation = async () => {
            try {
                const existingAppToken = await localStorage.getItem(APP_TOKEN)
                if (existingAppToken) {
                    const appToken = JSON.parse(decryptData(existingAppToken));
                    setAuth(appToken)
                    return appToken;
                }
            }
            catch (error) {
                dispatch(setAlert({ 
                    show: true, 
                    title: "ERROR", 
                    body: "Invalid Token. <br/><br/> Please login again from the main site." 
                }))
            }
        }

        const getLoggedInUserDetails = async (id) => {
            try{

                const user = await fetchUserByID(id);
                dispatch(setUserDetails(user))
                dispatch(setAgentDetails(user))
                dispatch(isLoading(false));
            }
            catch(err) {
                dispatch(setAlert({ 
                    show: true, 
                    title: "SERVER ERROR", 
                    body: err 
                }))
            }
        }

        const getFormsData = async () => {
            try {
                const data = await getAllPDFTemplates();
                dispatch(setFormTemplatesList(data));
            }
            catch (error) {
                alert(`SERVER ERROR: ${error} <br/><br/> Please refresh the page.`);

            }
        }

        const getAllAgents = async () => {
            try{

            const agents = await fetchAllUsers();
            //filtered to agents only and the employee group id is not null
            const allAgentsDetails =
                agents
                    // .filter(agent =>
                    //     agent.employee_group_id &&
                    //     !JSON.parse(agent.employee_group_id).includes(parseInt(ROLE_ID.HQ))
                    // )
                    .map(agent => ({
                        agentName: `${agent.full_name} (${agent.display_name})`,
                        agentID: agent.id,
                        agentTelNo: agent.phone || "",
                        agentCEANo: agent.cea_no || ""
                    })) 
                    .sort((a, b) => a.agentName.localeCompare(b.agentName));

            // setAllAgentDetails(agents)
            // console.log('get all agents')
            dispatch(setAllAgentNames(allAgentsDetails))
        }
        catch(err) {
            dispatch(setAlert({ 
                show: true, 
                title: "SERVER ERROR", 
                body: `${err} <br/><br/> Please refresh the page.`
            }))
        }

        }

        if (isMounted) {
            tokenValidation().then(result => {
                const userId = auth?.id || result?.id;
                getFormsData();
                getAllAgents();
                if (userId) {
                    getLoggedInUserDetails(userId);
                }
                else {
                    dispatch(isLoading(false));
                }
                

            })
                .catch(err => {
                    dispatch(setAlert({ show: true, title: "ERROR", body: `Invalid Token. <br/><br/> ${err}` }))

                })
        }

        return () => {
            isMounted = false;
        }

    }, [])


    return {
        appState,
        dispatch
    }
}

export default useApp;